export const DISCOUNT_PROGRAM_PAGE_REPLACER = '{{discount}}';
